import { useParams } from 'react-router-dom';
import type { DatovkaApiType } from '@gov-nx/api';
import { useExtraConfigContext } from '@gov-nx/core/app';
import { useTranslationWithNamespace } from '@gov-nx/core/service';
import type { Nullable } from '@gov-nx/core/types';
import {
	DataBoxFolderType,
	isArchiveNavigationVisible,
} from '@gov-nx/module/data-box';
import { PageCode } from '@gov-nx/module/page';
import { pageRouteResolver } from '@gov-nx/web';
import { DataBoxItemNavigationItem } from './DataBoxItemNavigationItem';

interface DataBoxItemNavigationProps {
	dataBox: DatovkaApiType;
	unreadMessagesCount: Nullable<number>;
}

export const DataBoxItemNavigation = ({
	dataBox,
	unreadMessagesCount,
}: DataBoxItemNavigationProps) => {
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const tn = getLocalizeCurried(PageCode['datove-schranky']);

	const { extraConfig } = useExtraConfigContext();

	const { dataBoxId, folderType } = useParams();

	return (
		<nav aria-label={tn('slozky.slozky')}>
			<ul className="flex flex-col gap-(--spacing-s) gov-list--plain m-0! p-0!">
				{!dataBox.odpojeno && (
					<>
						<DataBoxItemNavigationItem
							active={
								dataBoxId === dataBox.datovaSchrankaId &&
								folderType === DataBoxFolderType.Received
							}
							label={tn('slozky.dorucene')}
							url={pageRouteResolver('datove-schranky.schranka', {
								dataBoxId: dataBox.datovaSchrankaId,
								folderType: DataBoxFolderType.Received,
							})}
							unreadMessagesCount={unreadMessagesCount}
							icons={{ default: 'envelope-fill', active: 'envelope' }}
						/>

						<DataBoxItemNavigationItem
							active={
								dataBoxId === dataBox.datovaSchrankaId &&
								folderType === DataBoxFolderType.Sent
							}
							label={tn('slozky.odeslane')}
							url={pageRouteResolver('datove-schranky.schranka', {
								dataBoxId: dataBox.datovaSchrankaId,
								folderType: DataBoxFolderType.Sent,
							})}
							icons={{ default: 'send-fill', active: 'send' }}
						/>
					</>
				)}

				{isArchiveNavigationVisible(dataBox.typSchranky) &&
					extraConfig.pageRoutes.databoxConfig.displayArchiveFolder && (
						<DataBoxItemNavigationItem
							active={
								dataBoxId === dataBox.datovaSchrankaId &&
								folderType === DataBoxFolderType.Archived
							}
							label={tn('slozky.archiv')}
							url={pageRouteResolver('datove-schranky.schranka', {
								dataBoxId: dataBox.datovaSchrankaId,
								folderType: DataBoxFolderType.Archived,
							})}
							icons={{ default: 'archive-fill', active: 'archive' }}
						/>
					)}

				{extraConfig.pageRoutes.databoxConfig.displayBin ? (
					<DataBoxItemNavigationItem
						active={
							dataBoxId === dataBox.datovaSchrankaId &&
							folderType === DataBoxFolderType.Trash
						}
						label={tn('slozky.kos')}
						url={pageRouteResolver('datove-schranky.schranka', {
							dataBoxId: dataBox.datovaSchrankaId,
							folderType: DataBoxFolderType.Trash,
						})}
						icons={{ default: 'trash-fill', active: 'trash' }}
					/>
				) : null}
			</ul>
		</nav>
	);
};
